// extracted by mini-css-extract-plugin
export default {"socialIcon":"ContactInfo_socialIcon__TqBDz","tableItem":"ContactInfo_tableItem__p+ZvL"};